export default __webpack_public_path__ + "static/image-68-0de9d02115178482b232e17029530d6f.jpg";